import { ref } from "vue";
const bus = ref(new Map());

export default function useEventsBus(){

    function emiter(event, ...args) {
        bus.value.set(event, args);
        console.log(bus.value);
    }

    return {
        emiter,
        bus
    }
}
